import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import '../../css/FutureReadiness.css';
import { LoadingWrapper } from '../common';
import { TeamReadinessSection } from './TeamReadinessSection';

// ─── Empty state ──────────────────────────────────────────────────────────────

const EmptyState = () => (
    <div className="fr-empty-state">
        <Icon name="calendar outline" size="huge" className="fr-empty-state__icon" />
        <div className="fr-empty-state__title">No report generated yet</div>
        <div className="fr-empty-state__subtitle">
            Select a date range and click "Generate Report" to view readiness data.
        </div>
    </div>
);

const NoTeamsFound = () => (
    <div className="fr-no-teams">
        <Icon name="inbox" size="big" className="fr-no-teams__icon" />
        <div className="fr-no-teams__text">
            No teams found for the selected filters and date range.
        </div>
    </div>
);

// ─── FutureReadinessReport ────────────────────────────────────────────────────

export const FutureReadinessReport = ({ data, loading, error }) => {
    const renderContent = () => {
        if (error) {
            const is403 = error.startsWith('You do not have permission');
            return (
                <Message negative>
                    <Message.Header>{is403 ? 'Access Denied' : 'Error Loading Report'}</Message.Header>
                    <p>{error}</p>
                </Message>
            );
        }
        if (!data) return <EmptyState />;
        if (!data.teams?.length) return <NoTeamsFound />;
        return (
            <div>
                <div className="fr-report-header">
                    <div className="fr-report-date-range">
                        {data.startDate} &rarr; {data.endDate}
                    </div>
                    <div className="fr-report-team-count">
                        {data.teams.length} team{data.teams.length !== 1 ? 's' : ''}
                    </div>
                </div>
                {data.teams.map((team, idx) => (
                    <TeamReadinessSection key={team.id} team={team} defaultOpen={idx === 0} />
                ))}
            </div>
        );
    };

    return (
        <LoadingWrapper loading={loading} text="Loading readiness report…">
            {renderContent()}
        </LoadingWrapper>
    );
};
